import { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.min.css';
import {
  AUTHENTICATION,
  INCIDENT_CENTRAL_STATION,
} from '@rsos/constants/appNames';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import ThemeProvider from '@rsos/theme';
import { DARK_THEME, LIGHT_THEME } from '@rsos/theme/constants';
import { readMetaTag } from '@rsos/utils/metaTags';
import { AppPathsProvider } from './AppPathsContext';
import LayoutContent from './LayoutContent';
import useRebrandedFavicon from './useRebrandedFavicon';

const feAppName = readMetaTag('fe-app-name');

// The authentication renderer owns public login/logout screens. It can briefly
// hydrate persisted Redux auth state while those screens clear stale browser
// session data, so mounting SessionPortal there can leak a portal timeout modal
// onto the login page. Portal/product renderers still keep timeout tracking on.
export const shouldShowSessionPortal = app => app !== AUTHENTICATION;

const fetchTheme = (app, theme) => {
  const themeByApp = {
    [AUTHENTICATION]: LIGHT_THEME,
    [INCIDENT_CENTRAL_STATION]: DARK_THEME,
  };

  return themeByApp[app] || theme;
};

const Layout = ({ children, appPaths, persistor }) => {
  const selectedTheme = useSelectedTheme();

  // Centralized favicon for every app that mounts this Layout (RSP/CSP/ICSP/Admin/auth).
  useRebrandedFavicon();

  const [themeName, setThemeName] = useState(selectedTheme);

  useEffect(() => {
    setThemeName(fetchTheme(feAppName, selectedTheme));
  }, [selectedTheme]);

  return (
    <AppPathsProvider value={appPaths}>
      <ThemeProvider themeName={themeName}>
        <LayoutContent
          children={children}
          persistor={persistor}
          showSessionPortal={shouldShowSessionPortal(feAppName)}
        />
      </ThemeProvider>
    </AppPathsProvider>
  );
};

export default Layout;
